(function () {
  'use strict';

  const discountCodes = {
    RTR3MLS2: {
      message: 'Mindestbestellwert: 30 EUR. Das Gratis-Produkt muss im Warenkorb sein.'
    },
    '6R9MVX': {
      message: 'Mindestbestellwert: 30 EUR. Das Gratis-Produkt muss im Warenkorb sein.'
    },
    XKZC4: {
      message: 'Mindestbestellwert: 30 EUR. Das Gratis-Produkt muss im Warenkorb sein.'
    },
    FS7TXN: {
      message: 'Mindestbestellwert: 30 EUR. Das Gratis-Produkt muss im Warenkorb sein.'
    }
  };

  const genericError = 'Der Rabattcode, den Sie eingegeben haben, ist ungültig oder kann nicht auf diesen Warenkorb angewendet werden';
  let lastEnteredCode = '';
  let discountEnhanceQueued = false;
  let dingDoongCompactQueued = false;
  let tierProgressQueued = false;
  let lastCartTrigger = null;

  function getCartTrigger() {
    if (lastCartTrigger
      && document.contains(lastCartTrigger)
      && typeof lastCartTrigger.focus === 'function'
      && lastCartTrigger.matches('a[href], button')) {
      return lastCartTrigger;
    }

    return document.querySelector('#cart-icon-bubble, a.header__icon--cart[href], a[href="/cart"]');
  }

  function returnFocusToCartTrigger() {
    [0, 120, 320, 700, 1200, 1800].forEach((delay) => {
      window.setTimeout(() => {
        const cart = document.querySelector('.kaching-cart, #kaching-cart');
        const cartIsHidden = !cart
          || (!isKachingCartOpen(cart) && window.getComputedStyle(cart).visibility === 'hidden');
        const trigger = getCartTrigger();

        if (cartIsHidden && trigger) trigger.focus({ preventScroll: true });
      }, delay);
    });
  }

  function getCurrentDiscountCode() {
    const input = document.querySelector('.kaching-cart__discount-code-input')
      || document.querySelector('[class*="kaching-cart"] input[name="discount"]')
      || document.querySelector('input[placeholder="Discount code"]')
      || document.querySelector('input[name="discount"]');

    if (input && input.value) {
      return input.value.toUpperCase().trim();
    }

    return lastEnteredCode;
  }

  function findErrorElements() {
    const containers = document.querySelectorAll('.kaching-cart__discount-code-errors, [class*="kaching-cart__discount-code-errors"]');
    const results = [];

    containers.forEach((container) => {
      const paragraphs = container.querySelectorAll('p');

      paragraphs.forEach((paragraph) => {
        if (paragraph.textContent && paragraph.textContent.includes(genericError)) {
          results.push(paragraph);
        }
      });

      if (paragraphs.length === 0 && container.textContent && container.textContent.includes(genericError)) {
        results.push(container);
      }
    });

    return results;
  }

  function replaceErrorText() {
    const code = getCurrentDiscountCode();
    const config = discountCodes[code];

    if (!config) return;

    findErrorElements().forEach((element) => {
      element.textContent = config.message;
    });
  }

  function trackDiscountInput(event) {
    const target = event.target;
    if (!target || target.tagName !== 'INPUT') return;

    const placeholder = target.getAttribute('placeholder') || '';
    const name = target.getAttribute('name') || '';
    const isDiscountInput = target.classList.contains('kaching-cart__discount-code-input')
      || target.matches('[class*="kaching-cart"] input')
      || placeholder.toLowerCase().includes('discount')
      || name.toLowerCase().includes('discount');

    if (isDiscountInput) {
      lastEnteredCode = target.value.toUpperCase().trim();
    }
  }

  function findDiscountPanels() {
    const selectors = [
      '.kaching-cart__discount-code',
      '.kaching-cart__discount-code-form',
      '[class*="kaching-cart__discount-code"]',
      '[class*="kaching-cart__discount-code-form"]'
    ];
    const selector = selectors.join(',');

    return Array.from(document.querySelectorAll(selector)).filter((panel) => {
      const parentPanel = panel.parentElement && panel.parentElement.closest(selector);
      if (parentPanel) return false;

      return panel.querySelector('input')
        || panel.querySelector('[class*="discount-code-input"]')
        || panel.textContent.toLowerCase().includes('rabatt')
        || panel.textContent.toLowerCase().includes('discount');
    });
  }

  function getDiscountToggle(panel) {
    return panel.querySelector('[data-kaching-discount-toggle]');
  }

  function setDiscountToggleState(toggle, isOpen) {
    if (!toggle) return;

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    const icon = toggle.querySelector('[aria-hidden="true"]');
    if (icon) {
      icon.textContent = isOpen ? '-' : '+';
    }
  }

  function enhanceDiscountPanels() {
    discountEnhanceQueued = false;

    findDiscountPanels().forEach((panel) => {
      panel.classList.add('r-kaching-discount-panel');

      const input = panel.querySelector('input');
      const hasValue = input && input.value && input.value.trim();
      const errorElement = panel.querySelector('.kaching-cart__discount-code-errors, [class*="kaching-cart__discount-code-errors"]');
      const hasError = errorElement && errorElement.textContent.trim();

      if (hasValue || hasError) {
        panel.classList.add('is-open');
      }

      if (getDiscountToggle(panel)) return;

      const isOpen = panel.classList.contains('is-open');
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'r-kaching-discount-toggle';
      toggle.setAttribute('data-kaching-discount-toggle', '');
      toggle.innerHTML = `<span>Rabattcode</span><span aria-hidden="true">${isOpen ? '-' : '+'}</span>`;
      setDiscountToggleState(toggle, isOpen);

      toggle.addEventListener('click', () => {
        const nextIsOpen = panel.classList.toggle('is-open');
        setDiscountToggleState(toggle, nextIsOpen);

        if (nextIsOpen && input) {
          window.setTimeout(() => input.focus(), 40);
        }
      });

      panel.insertBefore(toggle, panel.firstElementChild);
    });
  }

  function scheduleDiscountEnhancement() {
    if (discountEnhanceQueued) return;
    discountEnhanceQueued = true;
    window.requestAnimationFrame(enhanceDiscountPanels);
  }

  function compactDingDoong() {
    dingDoongCompactQueued = false;
    const cart = document.querySelector('.kaching-cart, #kaching-cart');
    const footer = cart && cart.querySelector('.kaching-cart__footer');
    const root = footer && footer.querySelector([
      '.ot-dingdoong-root-cart-drawer-custom',
      '.ot-dingdoong-root-cart-drawer',
      '.ot-dingdoong-root',
      '.dingdoong-embed-root'
    ].join(','));

    if (root) {
      root.classList.add('r-dingdoong-tight');

      const title = root.querySelector('.ot-dingdoong-header__title, .ot-dingdoong-title');
      if (title && title.textContent !== 'Wunsch-Versandtag wählen') {
        title.textContent = 'Wunsch-Versandtag wählen';
      }

      const message = root.querySelector('.ot-dingdoong-header-additional-message');
      const dispatchMessage = 'Du wählst den Versandtag. An diesem Tag übergeben wir das Paket; die Zustellung erfolgt danach mit Tracking.';
      if (message && message.textContent !== dispatchMessage) {
        message.textContent = dispatchMessage;
      }

      root.querySelectorAll('.ot-dingdoong-dropdown__label, .ot-dingdoong-day-picker__label').forEach((label) => {
        if (/versanddatum|versandtag/i.test(label.textContent || '')) {
          if (label.textContent !== 'Versandtag wählen') label.textContent = 'Versandtag wählen';
        }
      });

      root.querySelectorAll('.ot-dingdoong-calendar__popover-button span').forEach((label) => {
        if (/versanddatum.*werktage/i.test(label.textContent || '')) {
          label.textContent = 'Versandtag wählen';
        }
      });
    }
  }

  function scheduleDingDoongCompact() {
    if (dingDoongCompactQueued) return;
    dingDoongCompactQueued = true;
    window.requestAnimationFrame(compactDingDoong);
  }

  function getTierProgressLabel(icon) {
    const title = icon.querySelector('.kaching-cart__tiered-promotions-bar-icon-tooltip-title');
    const text = title && title.textContent ? title.textContent : icon.textContent;

    return text ? text.replace(/\s+/g, ' ').trim() : '';
  }

  function enhanceTierProgressLabels() {
    tierProgressQueued = false;

    document.querySelectorAll('.kaching-cart__tiered-promotions-bar').forEach((bar) => {
      const progressContainer = bar.querySelector('.kaching-cart__tiered-promotions-bar-progress-container');
      const icons = Array.from(bar.querySelectorAll('.kaching-cart__tiered-promotions-bar-icon'));
      const labels = icons.map(getTierProgressLabel).filter(Boolean);

      if (!progressContainer || labels.length < 2) return;

      const labelKey = labels.join('|');
      let labelsRow = bar.querySelector('.r-kaching-progress-labels');

      bar.classList.add('r-kaching-progress-spaced');

      if (!labelsRow) {
        labelsRow = document.createElement('div');
        labelsRow.className = 'r-kaching-progress-labels';
        progressContainer.insertAdjacentElement('afterend', labelsRow);
      }

      labelsRow.style.setProperty('--r-progress-label-count', labels.length);

      if (labelsRow.getAttribute('data-r-labels') === labelKey) return;

      labelsRow.setAttribute('data-r-labels', labelKey);
      labelsRow.replaceChildren(...labels.map((label) => {
        const item = document.createElement('span');
        item.textContent = label;
        return item;
      }));
    });
  }

  function scheduleTierProgressLabels() {
    if (tierProgressQueued) return;
    tierProgressQueued = true;
    window.requestAnimationFrame(enhanceTierProgressLabels);
  }

  function localizeCartHeader() {
    document.querySelectorAll('.kaching-cart, #kaching-cart').forEach((cart) => {
      cart.setAttribute('aria-label', 'Mein Warenkorb');
      const header = cart.querySelector('.kaching-cart__header');
      const itemContainers = Array.from(cart.querySelectorAll('.kaching-cart-item-container'));
      if (!header) return;

      const helperHeadings = Array.from(header.querySelectorAll('[data-r-kaching-heading]'));
      const nativeHeading = header.querySelector('.kaching-cart__heading:not([data-r-kaching-heading]), [class*="heading"]:not([data-r-kaching-heading])');
      let heading = nativeHeading || helperHeadings[0];
      if (nativeHeading) {
        helperHeadings.forEach((helperHeading) => helperHeading.remove());
      } else {
        helperHeadings.slice(1).forEach((duplicate) => duplicate.remove());
      }
      if (!heading) {
        heading = document.createElement('span');
        heading.className = 'kaching-cart__heading';
        heading.setAttribute('data-r-kaching-heading', '');
        header.prepend(heading);
      }
      const headingText = (heading.textContent || '')
        .replace(/^Your cart/i, 'Mein Warenkorb')
        .replace(/\s*[•·]\s*0x\s*$/i, '')
        .trim();
      if (headingText) {
        if (heading.textContent !== headingText) heading.textContent = headingText;
      } else {
        heading.textContent = 'Mein Warenkorb';
      }

      const helperCloseButtons = Array.from(header.querySelectorAll('.r-kaching-cart-close'));
      const nativeCloseButton = header.querySelector('.kaching-cart__close:not(.r-kaching-cart-close), [aria-label*="close" i]:not(.r-kaching-cart-close), [aria-label*="schließen" i]:not(.r-kaching-cart-close)');
      if (nativeCloseButton) {
        helperCloseButtons.forEach((helperCloseButton) => helperCloseButton.remove());
        nativeCloseButton.setAttribute('aria-label', 'Warenkorb schließen');
      } else {
        helperCloseButtons.slice(1).forEach((duplicate) => duplicate.remove());
        if (!helperCloseButtons[0]) {
          const closeButton = document.createElement('button');
          closeButton.type = 'button';
          closeButton.className = 'kaching-cart__close r-kaching-cart-close';
          closeButton.setAttribute('aria-label', 'Warenkorb schließen');
          closeButton.innerHTML = '<span aria-hidden="true">×</span>';
          header.append(closeButton);
        }
      }

      if (itemContainers.length === 0) {
        const exactEmptyText = (element) => /^your cart is empty[.!]?$/i.test((element.textContent || '').trim());
        let emptyText = cart.querySelector('.kaching-cart__empty-cart-title, [class*="empty-cart-title"], [class*="empty"][class*="title"]');
        if (!emptyText || !exactEmptyText(emptyText)) {
          const candidates = Array.from(cart.querySelectorAll('h1, h2, h3, p, span, div')).filter(exactEmptyText);
          emptyText = candidates.find((element) => element.children.length === 0)
            || candidates.sort((a, b) => b.querySelectorAll('*').length - a.querySelectorAll('*').length).pop();
        }
        if (emptyText) {
          emptyText.textContent = 'Dein Warenkorb ist leer.';
          emptyText.setAttribute('data-r-kaching-empty-title', '');
          const emptyContainer = cart.querySelector('.kaching-cart__empty-cart-central-content-main, [class*="empty-cart-central-content-main"]')
            || emptyText.closest('[class*="central-content-main"], [class*="empty-content"]')
            || emptyText.parentElement;
          if (emptyContainer && !emptyContainer.querySelector('[data-r-kaching-empty-cta]')) {
            const emptyCta = document.createElement('a');
            emptyCta.href = '/collections/bio-fleisch-bestseller';
            emptyCta.className = 'r-kaching-empty-cta';
            emptyCta.setAttribute('data-r-kaching-empty-cta', '');
            emptyCta.textContent = 'Bestseller ansehen';
            emptyText.insertAdjacentElement('afterend', emptyCta);
          }
        }
      }

      const ariaTranslations = [
        ['Decrease quantity', 'Menge verringern'],
        ['Increase quantity', 'Menge erhöhen'],
        ['Quantity', 'Menge'],
        ['Previous slide', 'Vorherige Ansicht'],
        ['Next slide', 'Nächste Ansicht'],
        ['Go to previous month', 'Vorheriger Monat'],
        ['Go to next month', 'Nächster Monat'],
        ['Proceed to Checkout', 'Zur Kasse']
      ];

      cart.querySelectorAll('[aria-label]').forEach((element) => {
        const currentLabel = element.getAttribute('aria-label') || '';
        const exactMatch = ariaTranslations.find(([english]) => currentLabel === english);
        if (exactMatch) element.setAttribute('aria-label', exactMatch[1]);
        if (/^Remove .+ from cart$/i.test(currentLabel)) {
          const productName = currentLabel.replace(/^Remove\s+/i, '').replace(/\s+from cart$/i, '');
          element.setAttribute('aria-label', `${productName} aus dem Warenkorb entfernen`);
        }
        if (/^\d+(?:[.,]\d+)?\s*€\s*surcharge$/i.test(currentLabel)) {
          element.setAttribute('aria-label', currentLabel.replace(/surcharge/i, 'Aufpreis'));
        }
      });

      cart.querySelectorAll('.kaching-cart__discount-code-input, input[name="discount"]').forEach((input) => {
        if (/^discount code$/i.test(input.getAttribute('placeholder') || '')) input.setAttribute('placeholder', 'Rabattcode');
        if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Rabattcode');
      });

      cart.querySelectorAll('.kaching-cart__cart-discounts-title').forEach((title) => {
        if (/^discounts$/i.test((title.textContent || '').trim())) title.textContent = 'Rabatte';
      });
    });
  }

  function isKachingCartOpen(cart) {
    return Boolean(cart && (
      cart.classList.contains('active')
      || cart.classList.contains('is-open')
      || cart.classList.contains('kaching-cart--open')
      || cart.getAttribute('data-open') === 'true'
      || cart.getAttribute('aria-hidden') === 'false'
      || (cart.hasAttribute('open') && cart.getAttribute('open') !== 'false')
    ));
  }

  function announceCartState(isOpen) {
    document.dispatchEvent(new CustomEvent('jaesa:cart-state-change', {
      detail: { isOpen }
    }));
  }

  function dispatchCartEscape() {
    document.dispatchEvent(new KeyboardEvent('keydown', {
      key: 'Escape',
      code: 'Escape',
      bubbles: true
    }));
  }

  function closeKachingCart(cart) {
    if (!cart) return;

    const overlay = cart.querySelector('.kaching-cart__overlay');
    if (overlay && typeof overlay.click === 'function') {
      overlay.click();
    } else {
      dispatchCartEscape();
    }

    window.setTimeout(() => {
      if (isKachingCartOpen(cart)) dispatchCartEscape();
    }, 160);
    returnFocusToCartTrigger();
  }

  function manageCartDialogFocus() {
    document.querySelectorAll('.kaching-cart, #kaching-cart').forEach((cart) => {
      const isOpen = isKachingCartOpen(cart);

      if (!isOpen) {
        const wasOpen = cart.hasAttribute('data-r-kaching-open');
        cart.removeAttribute('data-r-kaching-open');
        if (window.getComputedStyle(cart).visibility === 'hidden') cart.setAttribute('inert', '');
        if (wasOpen) {
          announceCartState(false);
          returnFocusToCartTrigger();
        }
        return;
      }

      cart.removeAttribute('inert');
      if (cart.hasAttribute('data-r-kaching-open')) return;
      cart.setAttribute('data-r-kaching-open', '');
      announceCartState(true);
      if (document.activeElement
        && !cart.contains(document.activeElement)
        && document.activeElement.matches('a[href], button')) {
        lastCartTrigger = document.activeElement;
      }

      const closeButton = cart.querySelector('.kaching-cart__close');
      if (closeButton) window.requestAnimationFrame(() => closeButton.focus());
    });
  }

  function scheduleAppEnhancements() {
    scheduleDiscountEnhancement();
    scheduleDingDoongCompact();
    scheduleTierProgressLabels();
    window.requestAnimationFrame(localizeCartHeader);
    window.requestAnimationFrame(manageCartDialogFocus);
  }

  function init() {
    document.addEventListener('input', trackDiscountInput, true);
    document.addEventListener('click', (event) => {
      const trigger = event.target && event.target.closest && event.target.closest('.header__icon--cart, a[href="/cart"], a[href^="/cart?"]');
      if (trigger && !trigger.closest('.kaching-cart, #kaching-cart')) lastCartTrigger = trigger;
    }, true);
    document.addEventListener('focusin', (event) => {
      const panel = event.target && event.target.closest && event.target.closest('.r-kaching-discount-panel');
      if (!panel) return;
      if (event.target.closest('[data-kaching-discount-toggle]')) return;

      panel.classList.add('is-open');
      setDiscountToggleState(getDiscountToggle(panel), true);
    }, true);

    document.addEventListener('click', (event) => {
      const relevantControl = event.target && event.target.closest && event.target.closest([
        '.kaching-cart',
        '#kaching-cart',
        '.header__icon--cart',
        'a[href="/cart"]',
        'a[href^="/cart?"]'
      ].join(','));
      if (!relevantControl) return;
      scheduleAppEnhancements();
      replaceErrorText();
      window.setTimeout(scheduleAppEnhancements, 160);
    }, true);
    document.addEventListener('click', (event) => {
      const closeButton = event.target && event.target.closest && event.target.closest('.kaching-cart__close');
      if (!closeButton) return;

      if (closeButton.classList.contains('r-kaching-cart-close')) {
        closeKachingCart(closeButton.closest('.kaching-cart, #kaching-cart'));
      } else {
        returnFocusToCartTrigger();
      }
    }, true);
    document.addEventListener('keydown', (event) => {
      const cart = document.querySelector([
        '.kaching-cart.active',
        '.kaching-cart.is-open',
        '.kaching-cart.kaching-cart--open',
        '.kaching-cart[data-open="true"]',
        '.kaching-cart[aria-hidden="false"]',
        '.kaching-cart[open]:not([open="false"])',
        '#kaching-cart.active',
        '#kaching-cart.is-open',
        '#kaching-cart.kaching-cart--open',
        '#kaching-cart[data-open="true"]',
        '#kaching-cart[aria-hidden="false"]',
        '#kaching-cart[open]:not([open="false"])'
      ].join(', '));
      if (!cart) return;

      if (event.key === 'Escape') {
        returnFocusToCartTrigger();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(cart.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.offsetParent !== null);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, true);
    document.addEventListener('focusin', (event) => {
      if (event.target && event.target.closest && event.target.closest('.kaching-cart, #kaching-cart')) {
        scheduleDingDoongCompact();
        replaceErrorText();
      }
    }, true);

    scheduleAppEnhancements();
    [120, 420, 900].forEach((delay) => {
      window.setTimeout(scheduleAppEnhancements, delay);
    });

    let cartRootObserver = null;
    let cartStateObserver = null;
    let observedCartRoot = null;
    let cartMutationTimer = null;
    const observeCartRoot = () => {
      const cart = document.querySelector('.kaching-cart, #kaching-cart');
      if (!cart) {
        const removedCartWasOpen = observedCartRoot?.hasAttribute('data-r-kaching-open');
        if (cartRootObserver) cartRootObserver.disconnect();
        if (cartStateObserver) cartStateObserver.disconnect();
        window.clearTimeout(cartMutationTimer);
        cartMutationTimer = null;
        cartRootObserver = null;
        cartStateObserver = null;
        observedCartRoot = null;
        if (removedCartWasOpen) {
          announceCartState(false);
          returnFocusToCartTrigger();
        }
        return false;
      }
      if (cart === observedCartRoot && cartRootObserver) return true;
      const replacedCartWasOpen = observedCartRoot?.hasAttribute('data-r-kaching-open');
      if (cartRootObserver) cartRootObserver.disconnect();
      if (cartStateObserver) cartStateObserver.disconnect();
      window.clearTimeout(cartMutationTimer);
      cartMutationTimer = null;
      observedCartRoot = cart;

      cartRootObserver = new MutationObserver(() => {
        window.clearTimeout(cartMutationTimer);
        cartMutationTimer = window.setTimeout(() => {
          scheduleAppEnhancements();
          replaceErrorText();
        }, 120);
      });
      cartRootObserver.observe(cart, { childList: true, subtree: true, characterData: true });

      cartStateObserver = new MutationObserver(() => {
        window.requestAnimationFrame(manageCartDialogFocus);
      });
      cartStateObserver.observe(cart, {
        attributes: true,
        attributeFilter: ['class', 'data-open', 'aria-hidden', 'open']
      });
      if (replacedCartWasOpen && !isKachingCartOpen(cart)) {
        announceCartState(false);
        returnFocusToCartTrigger();
      }
      return true;
    };

    observeCartRoot();
    const injectionObserver = new MutationObserver(() => {
      const previousRoot = observedCartRoot;
      if (observeCartRoot() && observedCartRoot !== previousRoot) {
        scheduleAppEnhancements();
      }
    });
    injectionObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
